<template>
  <ul class="accordion" :class="type">
    <li class="accordion-item" v-for="(message, index) in data" :key="index">
      <div
        class="header"
        @click="openItem(index)"
        :class="{ open: index === activeIndex }"
      >
        {{ message.title }}
        <span class="icon" :class="{ rotate: index == activeIndex }"></span>
      </div>
      <transition
        name="accordion"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
      >
        <div
          :class="{ open: index === activeIndex }"
          class="message"
          v-show="activeIndex === index"
          v-html="message.text"
        ></div>
      </transition>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    messages: { required: true },
    type: { required: false, default: "default" },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    openItem: function(index) {
      this.activeIndex === index
        ? (this.activeIndex = null)
        : (this.activeIndex = index);
    },
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    },
  },
  computed: {
    data: function(t) {
      const self = this;
      let messages = t.messages.map((x) => JSON.parse(x));
      messages.forEach((message) => {
        this.$set(message, "isopen", false);
      });
      return messages.filter((message) => message.text);
    },
  },
};
</script>

<style lang="scss" scoped>
ul.accordion {
  max-width: 720px;
  margin: 0 auto 30px;
  text-align: left;

  li {
    list-style: none;
    padding: 15px 0;
    border-bottom: 1px solid rgba(45, 56, 76, 0.1);

    .header {
      cursor: pointer;
      font-family: $font-text-bolder;
      line-height: 18px;
      text-align: left;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-weight: 500;

      .icon {
        cursor: pointer;
        position: relative;
        height: 9px;
        width: 2px;

        &:before,
        &:after {
          background: #5C5C5C;
          content: "";
          left: 0;
          position: absolute;
          top: 0;
          height: 9px;
          width: 0.12em;
          transition: transform 500ms ease;
        }

        &:after {
          transform-origin: center;
          transform: rotate(90deg);
        }

        &.rotate {
          &:after {
            transform: rotate(270deg);
          }
          &:before {
            transform: rotate(90deg);
          }
        }
      }
    }

    .message {
      margin-top: 10px;
      transition: 150ms ease-in-out;
      font-family: $font-text-bolder;
      font-size: 14px;
      font-weight: 500;
    }
  }

  &.default {
    li {
      color: $dark-grey;
      margin-left: 10px;
    }

    .message {
      &.open {
        color: $brown;
      }

      ::v-deep a {
        color: $dark-grey;
        text-decoration: underline;
      }
    }

    .header {
      font-size: 15px;
      &.open {
        color: $brown;
      }
    }
  }

  &.product {
    li {
      color: inherit;
    }

    .message {
      ::v-deep a {
        color: $dark-grey;
        text-decoration: underline;
      }

      &.open {
        color: inherit;
      }
    }

    .header {
      font-size: 14px;

      &.open {
        color: inherit;
      }
    }
  }
}
</style>
